<div class="relative">
    <div class="grid grid-cols-6 gap-1.5 sm:gap-2" aria-hidden="true">
        @for (digit of codeSlots; track $index) {
            <div
                class="otp-slot"
                [class.otp-slot-active]="isFocused() && $index === activeSlot"
                [class.otp-slot-invalid]="isInvalid"
            >
                {{ digit }}
                @if (!digit && isFocused() && $index === activeSlot) {
                    <span class="otp-caret"></span>
                }
            </div>
        }
    </div>
    <input
        #codeInput
        [id]="inputId"
        [attr.data-testid]="testId"
        [value]="code"
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        spellcheck="false"
        [attr.aria-describedby]="describedBy"
        class="absolute inset-0 h-full w-full cursor-text text-[16px] opacity-0"
        (input)="onInput()"
        (click)="moveCaretToEnd()"
        (keyup)="moveCaretToEnd()"
        (focus)="isFocused.set(true)"
        (blur)="onBlur()"
    />
</div>
